const sections = document.querySelectorAll('.nav_section');
window.addEventListener('scroll', navHighlighter);

function navHighlighter() {
	let scrollY = window.pageYOffset;
	sections.forEach((current) => {
		const sectionHeight = current.offsetHeight;
		const sectionTop =
			current.getBoundingClientRect().top + window.pageYOffset - 50;
		var sectionId = current.getAttribute('id');

		if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
			document
				.querySelector('.main_menu li.menu-item a[href*=' + sectionId + ']')
				.classList.add('active_section');
		} else {
			document
				.querySelector('.main_menu li.menu-item a[href*=' + sectionId + ']')
				.classList.remove('active_section');
		}
	});
}
